import React, { useEffect, useState } from "react";
import Menu from './Menu';

export default function (props) {
    return (<div className='hiddenMenu'>
        <div style={{ background: '#012345', width: '100%' }} >
            {/* <h3 style={{ color: 'green' }}>Teste</h3> */}
        </div>
        <div className='hiddenComp'>
            <Menu />
        </div>
    </div>)
}